import { OrderProduct } from "ts/api/order";
import { FullProduct } from "ts/api/product";
import { round } from "lodash";
import calculateExtrasPrice from "../calculateExtrasPrice";

type CalculateFullProductPriceParams = {
  product: Pick<
    OrderProduct,
    "price" | "priceWithFees" | "quantity" | "extras"
  > &
    Pick<FullProduct, "cartQuantity">;
  includeFees?: boolean;
  selectedExtraIds?: string[];
  optionUplift?: number;
  excludeDiscount?: boolean;
};

export const calculateFullProductDiscount = (
  product: OrderProduct | FullProduct,
  includeFees = true
): number => {
  const {
    discountAmount = 0,
    discountAmountWithFees = 0,
    extras = [],
    quantity,
  } = product;
  const productDiscount =
    (includeFees ? discountAmountWithFees : discountAmount) *
    ((product as FullProduct)?.cartQuantity ?? quantity);
  const extrasDiscount = extras.reduce((acc, extra) => {
    const extraDiscount = includeFees
      ? extra.discountAmountWithFees ?? 0
      : extra.discountAmount ?? 0;

    return acc + extraDiscount * extra.quantity;
  }, 0);

  return productDiscount + extrasDiscount;
};

const calculateFullProductPrice = ({
  product,
  selectedExtraIds,
  includeFees,
}: CalculateFullProductPriceParams): number => {
  const { extras, price, priceWithFees } = product;

  const productPriceForItem = includeFees ? priceWithFees : price;

  const quantity =
    (product as FullProduct)?.cartQuantity || product?.quantity || 1;
  const productPrice = productPriceForItem * quantity;

  const extrasPrice: number = extras?.length
    ? calculateExtrasPrice({
        extras,
        selectedExtraIds,
        includeFees,
      })
    : 0;

  return productPrice + extrasPrice;
};

export default calculateFullProductPrice;
